// src/Lexprompt/components/VersionHistory.jsx

import React, { useState, useEffect } from "react";
import * as versionService from "../services/versionService";
import { computeDiff } from "../utils/difflib";
import "../pages/Sidebar.css";

export default function VersionHistory({ promptId }) {
  const [versions, setVersions] = useState([]);
  const [showDiff, setShowDiff] = useState(false);
  const [diffPair, setDiffPair] = useState({ old: "", current: "" });

  useEffect(() => {
    if (!promptId) return;
    const unsubscribe = versionService.subscribeToVersions(
      promptId,
      (list) => {
        setVersions(list);
      }
    );
    return () => unsubscribe();
  }, [promptId]);

  const handleViewDiff = async (versionId) => {
    const oldVer = await versionService.getVersion(promptId, versionId);
    const currentVer = await versionService.getLatestVersion(promptId);
    if (oldVer && currentVer) {
      const { oldText, newText } = computeDiff(
        oldVer.data.body,
        currentVer.data.body
      );
      setDiffPair({ old: oldText, current: newText });
      setShowDiff(true);
    }
  };

  return (
    <div className="sidebar-section">
      <h3>Version History</h3>
      <ul className="version-list">
        {versions.map((v) => (
          <li key={v.id} className="version-item">
            <span>
              {new Date(v.timestamp.seconds * 1000).toLocaleString()}
            </span>
            <button
              className="btn-secondary-sm"
              onClick={() => handleViewDiff(v.id)}
            >
              View
            </button>
          </li>
        ))}
      </ul>

      {showDiff && (
        <div className="diff-modal">
          <h4>Compare Versions</h4>
          <div className="diff-container">
            <pre className="diff-block">{diffPair.old}</pre>
            <pre className="diff-block">{diffPair.current}</pre>
          </div>
          <button
            onClick={() => setShowDiff(false)}
            className="btn-primary"
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
}
